/*
  Peter Augustus homepage | Reviews score, live from REVIEWS.io
  13 Oct 2026 | Theme 138814587088

  sections/pa-home-reviews.liquid prints the score and the number of reviews
  typed in the editor inside [data-reviews-rating] and [data-reviews-count],
  and the badge stars filled to that score. When the section comes within
  600px of the screen this asks the public REVIEWS.io API for the live numbers
  and writes them in. One call answers both choices of the "Count reviews
  from" setting:
  - all      stats: company, product and Google reviews, the numbers the old
             REVIEWS.io carousel on the homepage showed (its review_count)
  - company  storeStats: what the REVIEWS.io page itself shows
  If the call fails, the editor's numbers stay.

  The heading reveal (assets/pa-reveal.js) splits the heading into lines and
  puts the original HTML back when it ends, so the numbers are written again
  on its "pa:revealed" event.
*/
(() => {
  const API = 'https://api.reviews.io/timeline/data?type=store_review&sort=date_desc&page=1&per_page=1&include_product_reviews=1&include_local_reviews=1&store=';
  const requests = new Map();

  function apply(section) {
    const { liveRating, liveCount } = section.dataset;
    if (!liveRating) return;
    section.querySelectorAll('[data-reviews-rating]').forEach((el) => { el.textContent = liveRating; });
    section.querySelectorAll('[data-reviews-count]').forEach((el) => { el.textContent = liveCount; });
    section.querySelectorAll('[data-reviews-stars]').forEach((el) => {
      el.style.setProperty('--pa-rv-fill', `${(Number(liveRating) / 5) * 100}%`);
    });
  }

  function load(section) {
    const store = section.dataset.reviewsStore;
    if (!requests.has(store)) {
      requests.set(store, fetch(API + encodeURIComponent(store)).then((res) => (res.ok ? res.json() : Promise.reject(res.status))));
    }
    requests.get(store).then((data) => {
      const stats = section.dataset.reviewsFrom === 'company' ? data.storeStats : data.stats;
      const rating = Number(stats && stats.average_rating);
      const count = Number(stats && stats.review_count);
      if (!(rating > 0 && count > 0)) return;
      section.dataset.liveRating = rating.toFixed(2);
      section.dataset.liveCount = count.toLocaleString('en-AU');
      apply(section);
    }).catch(() => {});
  }

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        load(entry.target);
      });
    }, { rootMargin: '600px 0px' })
    : null;

  function scan(root) {
    root.querySelectorAll('[data-reviews-store]').forEach((section) => (observer ? observer.observe(section) : load(section)));
  }

  document.addEventListener('pa:revealed', (event) => {
    const section = event.target.closest && event.target.closest('[data-reviews-store]');
    if (section) apply(section);
  });
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document));
  else scan(document);
})();
